
function Header() {
  return (
    <header className="header p-3 sticky-top">
        <h1> Isa Cantarero</h1>
        <h2 className="fs-6 text-muted mb-0">&lt;Software Engineer/&gt;</h2>
    </header>
  );
}

export default Header;